<template>
  <aside class="sidebar col-sm-12 col-lg-3">
    <button @click.prevent="resetFilters" class="btn btn-black btn-block">
      <i class="fa fa-undo" aria-hidden="true"></i>
      Reset Filters
    </button>

    <SearchProducts v-if="displayFilterOptions" />
    <SortProducts v-if="displayFilterOptions" />
    <ColorFilters v-if="displayFilterOptions" />
    <filter-options :displayFilterOptions="displayFilterOptions"
      :hasSelectedParentCollection="hasSelectedParentCollection" />
  </aside>
</template>

<script>
import filterOptions from './filters/FilterOptions.vue';
import ColorFilters from './filters/ColorFilters';
import SearchProducts from "./filters/SearchProducts";
import SortProducts from "./filters/SortProducts";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "filters-sidebar",

  components: {
    SortProducts,
    SearchProducts,
    filterOptions,
    ColorFilters,
  },

  computed: {
    ...mapGetters([
      'searchText',
      'selectedCollectionCategory'
    ]),

    hasSelectedParentCollection() {
      const parentCollection = this.selectedCollectionCategory.parent_category_refs;

      if (parentCollection !== undefined && parentCollection.length && parentCollection[0].name === 'Collections') {
        return true;
      }

      return false;
    },

    activeSubCollections() {
      const parentCategory = this.selectedCollectionCategory.parent_category_refs;
      const subCategory = this.selectedCollectionCategory.sub_categories;

      if (parentCategory !== undefined && parentCategory.length) {
        return parentCategory[0].name === 'Collections' ? subCategory.filter((active) => {
          return active.enabled;
        }) : [];
      }

      return [];
    },

    displayFilterOptions() {
      if (this.hasSelectedParentCollection && this.activeSubCollections.length) {
        return false;
      } else if (this.hasSelectedParentCollection && !this.activeSubCollections.length) {
        return true;
      } else {
        return true;
      }
    },
  },

  methods: {
    ...mapActions([
      'resetFilters'
    ])
  }
}
</script>
